import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './Routes';

import * as serviceWorker from './services/serviceWorker';

ReactDOM.render(<Routes />,document.getElementById('sys-main'));

serviceWorker.unregister();
